export const STATUS_SUCESSO = "Processado com sucesso";
export const STATUS_PARCIAL = "Processado com sucesso parcial";
export const STATUS_ERRO = "Erro no processamento";

export function getImportSummary(mensagem) {
  if (!mensagem) return "-";

  const primeiraLinha = String(mensagem)
    .split("\n")
    .find((line) => line.trim());
  return primeiraLinha?.trim() || "-";
}

export function getImportSnackbarSeverity(status) {
  if (status === STATUS_PARCIAL) return "warning";
  if (status === STATUS_ERRO) return "error";
  return "success";
}

export function getImportSnackbarMessage(log) {
  if (!log) return "Arquivo importado com sucesso!";

  if (log.statusProcesso === STATUS_PARCIAL) {
    return log.mensagem || "Importação concluída com ressalvas.";
  }

  if (log.statusProcesso === STATUS_SUCESSO) {
    return log.mensagem || "Arquivo importado com sucesso!";
  }

  return log.mensagem || "Arquivo importado com sucesso!";
}
